<template>
  <div class="text-sm">
    <p class="mt-6">
      <b>2024.12.11</b> - Таверна: увеличены пороги peanut для улучшения/поддержания, и масштабирование
      наград предметами
    </p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>
        Баланс: стоимость ОД Дезинфекция увеличена: <code>10</code> -->
        <code>50 - Уровень</code>
      </li>
      <li>Исправлен баг ИИ, вызывающий бесконечные циклы (зависания)</li>
      <li>ИИ > Interference: разрешены последовательные способности CC (повтор при неудаче первой)</li>
      <li>
        Таверна
        <ul>
          <li>- Увеличены пороги peanut для улучшения/поддержания на 50%</li>
          <li>- Исправлено масштабирование качества наградных предметов</li>
          <li>- Исправлен баг, вызывающий обмены на неверный ранг</li>
        </ul>
      </li>
    </ul>
  </div>
</template>
